const doc = [({"da":({"js":({"admin":({"audits":({"page":({"what_happened_to":"Hvad der skete med", "what_did":"Hvad gjorde"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;